import { 
    REQUEST_SOURCE_MEDIA_FOR_PREVIEW, 
    RECEIVE_SOURCE_MEDIA_FOR_PREVIEW, 
    CLEAR_SOURCE_MEDIA_PREVIEW_VALUES, 
    SET_PREVIEW_MEDIA_SOURCE, 
    SET_MEDIA_ROW_OBJECT, 
    REQUEST_MEDIA_SEARCH, 
    RECEIVE_MEDIA_SEARCH 
} from '../constants/actionTypes';

const previewMediaInitialState = {
    isFetchingPreviewData: false,
    previewData: null,
    sourceUrl: '',
    mediaPreview: '',
    mediaRowObject: {},
    mediaSearchQuery: '',
    mediaSearchResult: {}
};

export const previewMedia = (state = previewMediaInitialState, action) => {
    switch (action.type) {
        case REQUEST_SOURCE_MEDIA_FOR_PREVIEW:
            return {
                ...state,
                isFetchingPreviewData: true,
            };

        case RECEIVE_SOURCE_MEDIA_FOR_PREVIEW:
            return {
                ...state,
                isFetchingPreviewData: false,
                previewData: action.previewData,
                sourceUrl: action.sourceUrl
            };

        case CLEAR_SOURCE_MEDIA_PREVIEW_VALUES:
            return previewMediaInitialState;

        case SET_PREVIEW_MEDIA_SOURCE:
            return {
                ...state,
                mediaPreview: action.mediaPreview
            };

        case SET_MEDIA_ROW_OBJECT:
            return {
                ...state,
                mediaRowObject: action.mediaRowObject
            };

        case REQUEST_MEDIA_SEARCH:
            return {
                ...state,
                mediaSearchQuery: action.mediaSearchQuery
            };

        case RECEIVE_MEDIA_SEARCH:
            return {
                ...state,
                mediaSearchResult: action.mediaSearchResult
            };            

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/previewMedia.js